import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { api, errMsg, eur } from '../api';
import { usePortal } from '../PortalAuth';
import { goldBtn, ghostBtn } from '../ui';
import { KIND } from './SubjectResult';
import { runCheck } from '../pages/ReputationalPage';

export default function FromReportDialog({ reportId }) {
  const navigate = useNavigate();
  const { refresh } = usePortal();
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [sel, setSel] = useState({});
  const [price, setPrice] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open || list) return;
    api.get(`/aml/report-subjects/${reportId}`).then((r) => { setList(r.data); setSel({ 0: true }); }).catch((e) => toast.error(errMsg(e)));
    api.get('/aml/status').then((r) => setPrice(r.data.price_cents)).catch(() => {});
  }, [open, list, reportId]);

  const chosen = (list || []).filter((_, i) => sel[i]);
  const start = async () => {
    setBusy(true);
    try { const c = await runCheck(chosen, reportId, refresh); navigate(`/portal/reputational/${c.id}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} className={`${ghostBtn} h-10`} data-testid="report-aml-btn"><ShieldAlert size={15} className="mr-2" />Reputational check</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-[#E5E5E5] max-w-2xl" data-testid="aml-report-dialog">
          <DialogHeader>
            <DialogTitle>Chi vuoi controllare?</DialogTitle>
            <DialogDescription className="text-[#8A8F97]">Azienda, esponenti e soci presi dal report. Ogni soggetto spuntato è un controllo ({eur(price)} l'uno).</DialogDescription>
          </DialogHeader>
          {!list ? <Loader2 className="animate-spin text-[#D4AF37] mx-auto my-6" /> : (
            <div className="max-h-[50vh] overflow-y-auto divide-y divide-[#1F242C] border border-[#1F242C]">
              <label className="px-4 py-2.5 flex items-center gap-3 text-xs text-[#8A8F97] cursor-pointer">
                <input type="checkbox" className="accent-[#D4AF37]" checked={chosen.length === list.length} onChange={(e) => setSel(e.target.checked ? Object.fromEntries(list.map((_, i) => [i, true])) : {})} data-testid="aml-select-all" />Seleziona tutti ({list.length})
              </label>
              {list.map((s, i) => (
                <label key={i} className="px-4 py-3 flex items-center gap-3 text-sm cursor-pointer" data-testid={`aml-candidate-${i}`}>
                  <input type="checkbox" className="accent-[#D4AF37]" checked={!!sel[i]} onChange={(e) => setSel({ ...sel, [i]: e.target.checked })} data-testid={`aml-candidate-${i}-checkbox`} />
                  <span className="flex-1 min-w-0"><span className="block truncate">{s.name}</span><span className="block text-xs font-mono text-[#5A5F67] truncate">{[KIND[s.kind], s.code, s.role].filter(Boolean).join(' · ')}</span></span>
                </label>
              ))}
            </div>
          )}
          <Button onClick={start} disabled={!chosen.length || busy} className={`${goldBtn} h-11`} data-testid="aml-report-start">
            {busy ? <Loader2 size={15} className="animate-spin" /> : `Avvia controllo su ${chosen.length} soggetti · ${eur(price * chosen.length)}`}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
